import { getVisibleMenuItems } from '../menu/menuNavigationUseCase';

/** Menu level of the popover entries (L3), so the breadcrumb popover keeps the same levels as the menu one */
const POPOVER_ITEMS_DEPTH = 3;

/**
 * Restrict the sub-menu of a breadcrumb item to its visible entries (same rules as the menu).
 * The item itself stays, even without path: it is part of the current path.
 * @param {ApiManagerBreadcrumb} item
 * @returns {ApiManagerBreadcrumb}
 */
export const getBreadcrumbItemWithVisibleChildren = (item) => {
  const children = getVisibleMenuItems(item.items, POPOVER_ITEMS_DEPTH);
  return { ...item, items: children.length ? children : null };
};
